

$(document).ready(function() {
  $(".button-collapse").sideNav({
    closeOnClick: true, // Closes side-nav on <a> clicks, useful for Angular/Meteor
    draggable: true // Choose whether you can drag to open on touch screens
  });
//sidenav mobile
// document.addEventListener('DOMContentLoaded', function() {
//   var elems = document.querySelectorAll('.sidenav');
//   var instances = M.Sidenav.init(elems, options);
// });

  // Or with jQuery

  //$('.sidenav').sidenav();
  $(".dropdown-trigger").dropdown();     
  console.log('aqui');
  //$('select').formSelect();   
  
  
  
  //collapsible
  
  // document.addEventListener('DOMContentLoaded', function() {
  //   var elems = document.querySelectorAll('.collapsible');
  //   var instances = M.Collapsible.init(elems, options);
  // });

  // Or with jQuery

  $('.collapsible').collapsible();

  
    $('select').material_select();

  $('#corpo_documento').trigger('autoresize');

  $('.modal').modal();

  $('.datepicker').pickadate({
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Sey', 'Out', 'Nov', 'Dez'],
    weekdaysFull: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    showMonthsShort: true,
    selectMonths: true, // Creates a dropdown to control month
    selectYears: 15, // Creates a dropdown of 15 years to control year
    format: 'dd/mm/yyyy',
    today: '',
    clear: '',
    close: ''
  });
});



// WEBPACK FOOTER //
// src/assets/js/custom.js